<template>
  <div class="demo">
    <button @click="onClick">click</button>
    <rich-text
      :jsonText="jsonText"
      readonly
    />
    <rich-text
      class="demo"
      :jsonText="jsonText"
      :errors="errors"
      @change="handleChange"
      @focus="handleFocus"
      @blur="handleBlur"
    />
  </div>
</template>

<script>
import RichText, { datelToHtml, htmlToDatel } from '@/components/rich-text';
import mockData from '@/components/rich-text/demo/mock.js';
import { digitsCheck } from '@/util/rtCheck.js';
export default {
  components: {
    RichText,
  },
  data() {
    return {
      mockJson: mockData,
      jsonText: JSON.stringify(mockData),
      errors: [
        {
          errorType: 'spell_error',
          position: [1, 6],
          payload: ['test', 'growing'],
        },
        {
          errorType: 'low_error',
          position: [14, 15],
          payload: ['test', 'growing'],
        },
      ],
    };
  },
  methods: {
    handleChange(...ops) {
      console.log('====change====', ops);
    },
    handleFocus(...ops) {
      console.log('====focus====', ops);
    },
    handleBlur(...ops) {
      console.log('=====数据原文: ', this.mockJson);
      console.log('=====数据译文: ', ops[1]);
      console.log('=====检测结果: ', digitsCheck(this.mockJson, ops[1]));
    },
    onClick() {
      this.errors = [
        {
          errorType: 'spell_error',
          position: [1, 3],
          payload: ['test', 'growing'],
        },
        {
          errorType: 'low_error',
          position: [5, 6],
          payload: ['句首字母应该大写', '多余空格'],
        },
      ];
    },
  },
  mounted() {
    // console.log('===================', mockData);
    /* console.log('====datelToHtml====', datelToHtml(mockData));
    console.log('====htmlToDatel====', htmlToDatel(datelToHtml(mockData))); */
  },
};
</script>

<style lang="scss" scoped>
.demo {
  margin: 100px;
}
</style>
